import React from 'react';
import {
  Box,
  Button,
  Divider,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import EditLocationAltIcon from '@mui/icons-material/EditLocationAlt';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import { formatValue } from '../configuracoesTab.utils';

export default function ConfigAreaPanel({
  form,
  localidades = [],
  loading = false,
  onOpenLocalidadeDialog,
  onDeleteLocalidade,
}) {
  return (
    <Paper variant="outlined" sx={{ p: 3, mb: 4, borderRadius: 3 }}>
      <Box display="flex" alignItems="center" gap={1} mb={1}>
        <EditLocationAltIcon color="primary" />
        <Box>
          <Typography variant="subtitle1" fontWeight="bold">
            Área válida para check-in
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Define onde o cliente precisa estar para validar um check-in.
          </Typography>
        </Box>
      </Box>

      <Paper variant="outlined" sx={{ p: 2, mt: 2, borderRadius: 2, backgroundColor: '#fafafa' }}>
        <Typography variant="subtitle2" fontWeight="bold" mb={1}>
          Local principal
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <Typography variant="caption" color="text.secondary">
              Latitude
            </Typography>
            <Typography fontWeight="bold">{formatValue(form.lat)}</Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="caption" color="text.secondary">
              Longitude
            </Typography>
            <Typography fontWeight="bold">{formatValue(form.long)}</Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="caption" color="text.secondary">
              Raio
            </Typography>
            <Typography fontWeight="bold">{formatValue(form.raio, ' m')}</Typography>
          </Grid>
        </Grid>
        <Box display="flex" alignItems="center" gap={1} mt={2} flexWrap="wrap">
          <Button
            variant="text"
            size="small"
            onClick={() => window.open(`https://www.google.com/maps/search/?api=1&query=${form.lat},${form.long}`, '_blank')}
            sx={{ color: 'text.secondary', fontWeight: 'bold' }}
          >
            Ver no Google Maps
          </Button>
          <Typography variant="caption" color="text.secondary">
            Apenas para conferir a posição no mapa.
          </Typography>
        </Box>
      </Paper>

      <Divider sx={{ my: 3 }} />

      <Typography variant="subtitle1" fontWeight="bold" mb={1}>
        Outros pontos válidos para check-in
      </Typography>
      <Typography variant="body2" color="text.secondary" mb={2}>
        Use esta opção se o restaurante possui mais de uma unidade ou áreas separadas.
      </Typography>

      {localidades.length === 0 ? (
        <Typography variant="body2" color="text.secondary" mb={2}>
          Nenhuma localidade adicional cadastrada ainda.
        </Typography>
      ) : (
        <TableContainer component={Paper} sx={{ mb: 2 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell><strong>Nome</strong></TableCell>
                <TableCell><strong>Raio (m)</strong></TableCell>
                <TableCell align="right"><strong>Ações</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {localidades.map((localidade) => (
                <TableRow key={localidade.id}>
                  <TableCell>
                    <Typography fontWeight="bold">
                      {localidade.nome || '-'}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Lat: {localidade.lat ?? '-'} / Long: {localidade.long ?? '-'}
                    </Typography>
                  </TableCell>
                  <TableCell>{localidade.raio != null ? `${localidade.raio} m` : '-'}</TableCell>
                  <TableCell align="right">
                    <Button
                      size="small"
                      variant="text"
                      onClick={() => onOpenLocalidadeDialog(localidade)}
                      disabled={loading}
                      sx={{ textTransform: 'none', color: 'text.secondary' }}
                    >
                      Editar
                    </Button>
                    <Button
                      size="small"
                      variant="text"
                      color="error"
                      onClick={() => onDeleteLocalidade(localidade.id)}
                      disabled={loading}
                      sx={{ textTransform: 'none' }}
                    >
                      Excluir
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <Box>
        <Button
          variant="outlined"
          startIcon={<AddLocationAltIcon />}
          onClick={() => onOpenLocalidadeDialog()}
          disabled={loading}
          sx={{
            fontWeight: 'bold',
            borderColor: '#FF2D54',
            color: '#FF2D54',
            '&:hover': { borderColor: '#e02548', color: '#e02548' },
          }}
        >
          Adicionar localidade
        </Button>
        <Typography variant="caption" color="text.secondary" display="block" mt={1}>
          Defina o raio de cada ponto adicional.
        </Typography>
      </Box>
    </Paper>
  );
}
